import React from 'react';
import style from './index.module.scss';
import Header from './Header';
import Table from './Table';

const Page = (props) => {
    return (
        <div className={style['wrapper']}>
            <div className="header_wrapper">
                <Header />
            </div>
            <div className="content_wrapper">
                <div className="inner_wrapper">
                    <Table />
                </div>
            </div>
        </div>
    );
};

export default Page;
